import type { LensTheme } from '@diligentcorp/atlas-theme-mui-lens';
import { Box, useTheme } from '@mui/material';
import React from 'react';
import { SwitchField } from '../SwitchField/SwitchField';

interface Props {
  checked: boolean;
  disabled?: boolean;
  title: string;
  subtitle: string;
  onChange: () => void;
  children?: React.ReactNode;
}

export const RetentionPeriodToggle: React.FC<Props> = ({
  checked,
  disabled = false,
  title,
  subtitle,
  onChange,
  children,
}) => {
  const theme = useTheme<LensTheme>();
  const color = theme.tokens.semantic.color;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        padding: theme.tokens.semantic.spacing.desktop.gap['2_5'].value,
        border: `1px solid ${color.outline.disabled.value}`,
        borderRadius: theme.tokens.semantic.radius.md.value,
      }}
    >
      <SwitchField
        checked={checked}
        disabled={disabled}
        label={title}
        description={subtitle}
        onChange={onChange}
      />
      {children}
    </Box>
  );
};
